import { Box, Image } from "@chakra-ui/react";

function NotFound() {

    const image = "https://static.vecteezy.com/ti/vetor-gratis/p3/3393235-error-404-with-the-cute-floppy-disk-mascot-gr%C3%A1tis-vetor.jpg"
  return (
    <>
        <Image w={'40vw'} h={'80vh'}m={'auto'}src={image} />
    </>
  );
}
export default NotFound;